/** Query keys that must never linger in the address bar / Referer after a form leak. */
const SECRET_QUERY_KEYS = new Set([
  'passphrase',
  'password',
  'current',
  'new',
  'confirm',
  'passwordConfirm',
]);

/**
 * Remove accidental credential query params from the current URL.
 * Safe no-op when none of the known secret keys are present.
 */
export function stripSecretQueryParams(
  location: Pick<Location, 'pathname' | 'search' | 'hash'> = window.location,
  historyApi: Pick<History, 'replaceState'> = window.history,
): boolean {
  if (!location.search) {
    return false;
  }

  const params = new URLSearchParams(location.search);
  let removed = false;
  for (const key of [...params.keys()]) {
    if (SECRET_QUERY_KEYS.has(key)) {
      params.delete(key);
      removed = true;
    }
  }

  if (!removed) {
    return false;
  }

  const search = params.toString();
  const next = `${location.pathname}${search ? `?${search}` : ''}${location.hash}`;
  historyApi.replaceState({}, '', next);
  return true;
}
